import { render, staticRenderFns } from "./wenzhengRanking.vue?vue&type=template&id=43e1034a&scoped=true&"
import script from "./wenzhengRanking.vue?vue&type=script&lang=ts&"
export * from "./wenzhengRanking.vue?vue&type=script&lang=ts&"
import style0 from "./wenzhengRanking.vue?vue&type=style&index=0&id=43e1034a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e1034a",
  null
  
)

export default component.exports